import { between, createTheme, down, only, up } from 'styled-breakpoints'

const base = {
  primary: 'pink',
  secondary: 'black',
  shade: {
    white: ['#FFFFFF', '#FBFBFB', '#F5F5F6', '#FFFFFFE5'],
    blue: [
      '#A3B9CC', //0
      '#0E86D4', //1
      '#00adef', //2 #Vimeo base color
      '#DBE6EF', //3
      '#A3B9CC', //4
      '#33b5e5', //5
      '#25c2e3', //6
    ],
    pink: [
      '#F0E4E1',
      '#DABBB7',
      '#ec5b57',
      '#dabbb7',
      '#f0e4e1',
      '#f3e3e1',
      '#e1b8b5',
      '#EEE7E1',
      '#f1dfde',
    ],
    red: [
      '#ff0000', // 0
      '#ff4d4f', // 1
      '#cc000057', // 2
      '#803026', // 3
      '#EB6D6D', //4
    ],
    green: ['#D2FAB2', '#1D6B16', '#a3ea28', '#40a829'],
    brown: ['#804500'],
    orange: ['#ffe5b4', '#ff9900'],
  },
  grey: [
    '#F8F8F8', // 0
    '#F5F5F5', // 1
    '#F0F0F0', // 2
    '#E8E8E8', // 3
    '#E0E0E0', // 4
    '#DCDCDC', // 5
    '#D8D8D8', // 6
    '#D3D3D3', // 7
    '#D0D0D0', // 8
    '#C8C8C8', // 9
    '#C0C0C0', // 10
    '#D9D9D9', // 11
    '#FFFFFF', // 12
    '#F5F5F6', // 13
    '#A6A6A6', // 14
    '#B3B3B3', // 15
    '#F5F5F6', // 16
    '#343E47', // 17
    '#F8F8F9', // 18
    '#999999', // 19
    '#EBEBEB', // 20
    '#d9d9d9', // 21
    '#dddddd', // 22
    '#f1f1f1', // 23
    '#f5f5f6', // 24
    '#B3B3B3', // 25
    '#D6CBBE', // 26
    '#A6ACAE', // 27
  ],
  // dark: [
  //   '#696969', // 0
  //   '#686868', // 1
  //   '#606060', // 2
  //   '#585858', // 3
  //   '#505050', // 4
  //   '#484848', // 5
  //   '#202020', // 6
  //   '#181818', // 7
  //   '#101010', // 8
  //   '#080808', // 9
  //   '#000000', // 10
  //   '#7F8B9D', // 11
  //   '#303030', // 12
  //   '#1e2e4e', // 13
  // ],
}

const space = (unit: string) => [
  `0.5${unit}`,
  `1${unit}`,
  `1.5${unit}`,
  `2${unit}`,
  `2.5${unit}`,
  `3${unit}`,
  `3.5${unit}`,
]

const defaultBreakpoints = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
}

const point = createTheme(defaultBreakpoints)

const typography = {
  font: {
    oxygen: 'Oxygen',
    DMSerifDisplay: 'DMSerifDisplay',
  },
  size: {
    xsm: 0.6,
    sm: 0.8,
    md: 1,
    lg: 1.8,
    eta: 2.4,
  },
}

const themes = {
  base,
  typography,
  space,
  breakpoint: {
    point,
    up,
    down,
    between,
    only,
  },
}

export default themes
